import { useState } from 'react';
import { captureException } from '@pegasus/sentry';
import { CustomerGender } from './types';
import { getTopPicks } from './request';
export function useTopPick4U(gender) {
    if (gender === void 0) { gender = CustomerGender.FEMALE; }
    var _a = useState(0), retry = _a[0], setRetry = _a[1];
    var _b = useState(false), error = _b[0], setError = _b[1];
    var _c = useState(false), loading = _c[0], setLoading = _c[1];
    var _d = useState([]), topPics4U = _d[0], setTopPics4U = _d[1];
    if (!loading && !topPics4U.length && retry < 2) {
        setLoading(true);
        setRetry(retry + 1);
        getTopPicks(gender)
            .then(function (topPicks) { return setTopPics4U(topPicks || []); })
            .catch(function () {
            setError(true);
            captureException(new Error("Error on getting top picks for = ".concat(gender)));
        })
            .finally(function () { return setLoading(false); });
    }
    return [topPics4U, loading, error];
}
